const DeviceInfo = {
  getApplicationName: () => 'aSeller',
  getVersion: () => 'web-preview',
  getBuildNumber: () => '1',
  getBundleId: () => 'com.aseller.web',
  getSystemVersion: () => 'web',
  getSystemName: () => 'web',
  getModel: () => 'browser',
  getDeviceId: () => 'web',
  getUniqueId: () => 'web-uid',
  isTablet: () => false,
  isEmulator: async () => false,
  hasNotch: () => false,
  isPinOrFingerprintSet: async () => false
};

export default DeviceInfo;
